import React, { ReactNode } from 'react'
import { FormattedMessage } from 'react-intl'
import { Link, Typography } from '@carto/meridian-ds/components'
import { Box, Grid } from '@mui/material'

interface BasicPageFilterResultsProps {
  results: ReactNode | string
  linkTitle?: string
  linkLabel?: string
  linkAction?: () => void
}

function BasicPageFilterResults({ results, linkTitle, linkAction, linkLabel }: BasicPageFilterResultsProps) {
  return (
    <Grid item xs={12} mt={2} display="flex" alignItems="center">
      <Typography variant="subtitle2">{results}</Typography>

      {linkAction && (
        <Box display="flex" ml={1}>
          <Link variant="subtitle2" aria-label={linkLabel} component="button" onClick={linkAction}>
            <FormattedMessage id={linkTitle || 'common.button.clear'} />
          </Link>
        </Box>
      )}
    </Grid>
  )
}

export default BasicPageFilterResults
